<template>
  <div
    v-if="subscriptionWithoutPayment"
    class="bg-orange-lightest text-orange-dark px-4 py-3 text-sm"
    role="alert"
  >
    <span class="font-semibold">Payment method missing:</span>
    your card could not be verified, so no payment method is saved for
    "{{ subscriptionWithoutPayment.vault ? subscriptionWithoutPayment.vault.name : "your subscription" }}".
    <router-link
      v-if="subscriptionWithoutPayment.vault"
      :to="{
        name: 'update-billing-details',
        params: { vault_id: subscriptionWithoutPayment.vault.id },
      }"
      class="underline text-orange-dark font-semibold"
    >
      Update your billing details
    </router-link>
    <span v-else>Please update your billing details</span>
    to keep your subscription active.
  </div>
</template>

<script>
// Shown app-wide while a subscription owned by the user has no saved
// payment method (has_payment_method = false), e.g. after the $0 card
// verification failed during registration. Clears itself once billing
// details are saved successfully.
export default {
  name: "PaymentMethodBanner",
  data() {
    return {
      subscriptions: [],
    };
  },
  computed: {
    subscriptionWithoutPayment() {
      return (
        this.subscriptions.find((s) => s.has_payment_method === false) || null
      );
    },
  },
  mounted() {
    this.fetchSubscriptions();
  },
  watch: {
    // re-check after the user navigates, so the banner disappears
    // right after billing details are fixed
    $route() {
      if (this.subscriptionWithoutPayment) {
        this.fetchSubscriptions();
      }
    },
  },
  methods: {
    async fetchSubscriptions() {
      try {
        const { data } = await axios.get("api/users/subscriptions");
        this.subscriptions = Array.isArray(data) ? data : [];
      } catch (e) {
        // the banner is informational; never block the app on it
        this.subscriptions = [];
      }
    },
  },
};
</script>
